<template>
    <form class="section-hom-form form-horizontal" @submit.prevent="submit()">
        <div class="form-group"  >
            <label for="title" class="col-sm-2 control-label">Nombre Sección</label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title" v-model="data.section.title"  required :readonly="edit">
                <div class="help-block" v-for="e in errors['title']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group" :class="{'has-error': errors['title_section']}">
            <label for="title" class="col-sm-2 control-label">Titulo </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="title_section" v-model="data.section.title_section"  required >
                <div class="help-block" v-for="e in errors['title_section']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div v-if="data.section.id === 3" class="form-group">
             <label for="title" class="col-sm-2 control-label">Url Iframe </label>
            <div class="col-sm-10">
                <input type="text" class="form-control" id="iframe" v-model="data.section.iframe"  required />
                <div class="help-block" v-for="e in errors['iframe']">{{e}}</div>
            </div>
            <br><br>
        </div>
        <div class="form-group"  :class="{'has-error': errors['active']}">
            <label for="" class="col-sm-2 control-label">Activo</label>
            <div class="col-sm-10">
                <el-switch
                    v-model="data.section.active"
                    on-text="SI"
                    off-text="NO"                    
                >
                </el-switch>
            </div>
            <br><br> 
        </div>
        <template v-if="data.section.id === 2">
            <!-- <div hidden='true' class="form-group" :class="{'has-error': errors['nrodays']}">
                <label for="nrodays" class="col-sm-2 control-label">Nro Días Selección </label>
                <div class="col-sm-10">
                    <input type="number" class="form-control" id="nrodays" v-model="days" :min="1"    style="width:85px"   required />
                    
                </div>
                <br><br> 
            </div> -->
            
            <div  class="form-group" >
                <label for="nromeses" class="col-sm-2 control-label">Orden de Categorías</label>
                <div class="col-sm-10">
                    <div  class="panel panel-default" >
                        <div class="panel-heading">
                            <h3 class="panel-title">Listado de Categorías</h3>
                        </div>
                        <div class="panel-body">
                            <table class="table" width="90%">
                                <thead>
                                    <tr>
                                        <th>Orden</th>    
                                        <th>Categoría</th>
                                        <th>Ordenar</th>
                                        <th>Tiene Destacadas</th>
                                        <th>Editar Categoria</th>
                                        <th>Destacar Fichas</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(item, index) in data.categories">
                                        <td style="align:center">{{index+1}}</td>
                                        <td>{{item.name}}</td>
                                        <td style="text-align:center;">
                                            <a href="#"  @click.prevent="up(index)"><i class="material-icons">arrow_upward</i></a>
                                            <a href="#"  @click.prevent="down(index)"><i class="material-icons">arrow_downward</i></a>
                                        </td>
                                        <td style="text-align:center;">{{ item.feateured > 0 ? 'Si ('+ item.feateured +') ':'No'  }}</td>
                                        <td style="text-align:center;">
                                            <a :href="'backend/categorias/' + item.id +'/edit'"><i class="material-icons">create</i></a>
                                        </td>
                                        <td style="text-align:center;"><a :href="item.url" data-toggle="tooltip" title="Agregar Destadas"><i class="material-icons">create</i></a></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
            
            <!-- <div class="form-group" >
                <label for="nrodays" class="col-sm-2 control-label">Nro Filas Despliegue </label>
                <div class="col-sm-10">
                    <input type="number" class="form-control" id="nrofilas" v-model="row" :min="1"  :max="maxrows" style="width:65px"  required />
                    <!-- <input type="number" class="form-control" id="nrodays" v-model="data.nrodays" :min="1"  :max="36" required /> -->
                    <!-- style="width:65px" -->
            <!--     </div>
            </div> -->
          
       </template>

        <template  v-if="data.section.id === 1">
            <div class="form-group" :class="{'has-error': errors['title']}">
                <label for="title" class="col-sm-2 control-label">Texto Boton</label>
                <div class="col-sm-10">
                    <input type="text" class="form-control" id="button_text" v-model="data.section.button_text"  required />
                    <div class="help-block" v-for="e in errors['button_text']">{{e}}</div>
                </div>
                <br><br>
            </div>
        </template>
        
        <div class="form-group">
            <div class="col-sm-offset-2 col-sm-10">
                <a class="btn btn-default" href="backend/sections-home/">Cancelar</a>
                <button type="submit" class="btn btn-primary">Guardar</button>
            </div>
        </div>
    </form>
</template>
<style lang="scss" scoped>
    .el-select{
        display: block;
    }
</style>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import ElementUI from 'element-ui';
import ElSelect from 'element-ui/lib/select';
import ElOption from 'element-ui/lib/option';
import ElSwitch from 'element-ui/lib/switch';
import Multiselect from "vue-multiselect";
import locale from 'element-ui/lib/locale/lang/es';
import Vue from 'vue';
import { Message } from 'element-ui';
Vue.use(ElementUI, { locale });


export default {
    
    data: function(){
        const seccionhome = _.cloneDeep(this.seccionhome);
        const categories = _.cloneDeep(this.categories);
       

        var data = {
            section:seccionhome,
            categories:categories
        };

        return {
            data : data, 
            row: seccionhome.row,
            days:seccionhome.days,
            maxrows:(categories.length/3),
            errors: {}
        }
    },
    props: ["seccionhome", "edit" ,'categories','pages'],  
    components:{
        ElSwitch,
        Multiselect, 
        ElSelect,
        ElOption
    },
    watch:{
        row: function(r){
            if(r <= 0 )
                this.row = 1;
            else if(r > this.maxrows )
                this.row = this.maxrows;
            else
                this.row = r;

            this.data.section.row =  parseInt(this.row);
            
        },
        days:function(d){
            if(d <= 0 )
                this.days = 1;
            else
                this.days = d;

            this.data.section.days =  parseInt(this.days);
        }
    },
    methods:{
        validateForm:function(){
            this.errors = {};

            var title = this.data.title === '' || this.data.title === null;
            var title_length = this.data.title.length> 255;
            var errores = {};

            if(title){ errores["title"] = ["El campo Nombre Sección no puede estar vacío."]; }
            if(title_length){ errores["title"] = ["El campo Nombre Sección no puede exceder los 255 caracteres."]; }


            if(title || title_length){
                this.errors = errores;
                return true; 
            }else{
                return false;
            }
        },
        submit:function(){
            if(!this.validateForm){
                this.$message.error('Revise los errores en el formulario antes de continuar.');    
            }else{

                axios({
                     url: this.edit
                        ? "backend/sections-home/" + this.data.section.id
                        : "backend/sections-home",
                        method: this.edit ? "PUT" : "POST",
                    data: this.data
                })
                .then(response => {
                    window.location.replace(response.data.redirect);
                })
                .catch(error => {
                    this.errors = error.response.data.errors;
                });
            }
        },
        up: function(from){
            if(from == 0)
                return;

            var to = from - 1;
            var pos = 1 ;

            this.data.categories.splice(to, 0, this.data.categories.splice(from, 1)[0]);

            this.data.categories.forEach(c => {
                c.order_home = pos;
                pos++;
            });

        },
        down: function(from){
            var to = from + 1;
            var pos = 1 ;
            this.data.categories.splice(to, 0, this.data.categories.splice(from, 1)[0]);
            this.data.categories.forEach(c => {
                c.order_home = pos;
                pos++;
            });
        }
    }
}
</script>